import shouldForwardProp from "@styled-system/should-forward-prop";
import { PropsOf } from "src/typeUtils";
import React from "react";
import styled from "styled-components/native";
import {
  LayoutProps,
  FlexboxProps,
  BorderProps,
  SpaceProps,
  MarginProps,
  ColorProps,
  BackgroundProps,
  PositionProps,
} from "styled-system";
import {
  background,
  border,
  color,
  flexbox,
  layout,
  margin,
  position,
  space,
} from "styled-system";

/**
 * Box is the basic building block.
 * It abstracts a div on web and a View on mobile
 */
export type BoxStyleProps = LayoutProps &
  FlexboxProps &
  BorderProps &
  SpaceProps &
  MarginProps &
  ColorProps &
  BackgroundProps &
  PositionProps;

export type BoxProps = BoxStyleProps & { onClick?: () => void };

export const Box = styled.Pressable.withConfig<BoxProps>({
  shouldForwardProp: (prop: string) =>
    ["onLayout"].indexOf(prop) >= 0 || shouldForwardProp(prop),
})<BoxProps>`
  ${layout}
  ${flexbox}
    ${border}
    ${space}
    ${margin}
    ${color}
    ${background}
    ${position}
    box-sizing:border-box;
`;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
// export const Box = ({
//   onClick,
//   onPress,
//   ...props
// }: PropsOf<typeof BoxComponent>) => (
//   <BoxComponent onPress={onPress || onClick} {...props} />
// );
/**
 * A Box with flex and forced horizontal orientation.
 */
//@ts-ignore
export const HBox = styled(Box)`
  display: flex;
  flex-direction: row;
`;
//@ts-ignore
export const VBox = styled(Box)`
  display: flex;
  flex-direction: column;
`;

